import { render, staticRenderFns } from "./ManageOverlappingModal.vue?vue&type=template&id=449bddfb&scoped=true&"
import script from "./ManageOverlappingModal.vue?vue&type=script&lang=ts&"
export * from "./ManageOverlappingModal.vue?vue&type=script&lang=ts&"
import style0 from "./ManageOverlappingModal.vue?vue&type=style&index=0&id=449bddfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449bddfb",
  null
  
)

export default component.exports